const ENERGY_LABEL_LEADS = {
  title: 'Leads étiquetage énergétique',
  description: 'Vue d’ensemble des leads pour l’étiquetage énergétique',
  searchPlaceholder: 'Rechercher des leads …',
  emptyState: 'Aucun lead trouvé.',
  importButton: 'Importer Excel',
  importError: 'Impossible d’importer le fichier.',
  importEmpty: 'Le fichier ne contenait aucune ligne.',
  importSummary: '{imported} lignes sur {received} importées.',
  importRejected: 'Lignes rejetées :',
  importRow: 'Ligne {row}',
  importErrors: {
    required: '{field} est manquant',
    invalid: '{field} n’est pas valide',
    // more precise than the generic wording, worth its own key
    organizationNumber_invalid:
      'Le numéro d’organisation doit comporter 9 chiffres',
  },
  importFields: {
    contactPerson: 'Personne de contact',
    organizationNumber: 'Numéro d’organisation',
    contactEmail: 'E-mail',
    contactPhone: 'Téléphone',
    companyName: 'Nom de la société',
  },
  assignToMe: 'M’attribuer ce lead',
  assignToMeNeedsEnovaGuid:
    'Votre utilisateur n’a pas de GUID personnel Enova et ne peut donc pas prendre de leads.',
  backToList: 'Retour aux leads',
  unassigned: 'Non attribué',
  loadError: 'Impossible de charger les leads.',
  assignError: 'Impossible d’attribuer le lead.',
  notFound: 'Lead introuvable.',
  importNotImplemented: 'L’import Excel n’est pas encore implémenté.',
  commentSaveError: 'Impossible d’enregistrer la note.',
  commentSaved: 'Note enregistrée.',
  daysAgo: 'il y a {count} jours',
  missingAddress: 'Adresse manquante',
  deleteConfirmTitle: 'Supprimer le lead',
  deleteConfirmMessage:
    'Voulez-vous vraiment supprimer ce lead ? Cette action est irréversible.',
  deleteError: 'Impossible de supprimer le lead.',
  archiveError: 'Impossible d’archiver le lead.',
  blockError: 'Impossible de bloquer le lead.',
  blockNotYours:
    'Seul le conseiller à qui ce lead est attribué peut le bloquer.',
  blockWrongStatus: 'Un lead ne peut être bloqué que pendant la visite.',
  archiveConfirmTitle: 'Archiver le lead',
  archiveConfirmMessage:
    'Voulez-vous vraiment archiver ce lead ? Il sera marqué comme archivé et quittera les dossiers ouverts.',
  archiveNotAllowed: 'Un lead terminé ne peut pas être archivé.',
  assignWrongStatus:
    'Un lead ne peut être attribué que lorsque son statut est Formulaire complété, Attribué à un conseiller, Bloqué ou Informations manquantes.',
  actions: {
    archive: 'Archiver',
    block: 'Bloquer',
    unblock: 'Débloquer',
  },
  lifecycle: {
    title: 'Cycle de vie',
    steps: {
      imported: 'Lead importé',
      created: 'Créé — formulaire envoyé au client',
      formCompleted: 'Client prêt — prêt pour le conseiller',
      inspectionStarted: 'Attribué à un conseiller',
      inspectionCompleted: 'Conseiller terminé',
      completed: 'Certificat énergétique délivré',
    },
  },
  building: {
    title: 'Bâtiment',
    buildingNumber: 'Numéro de bâtiment',
    buildingType: 'Type de bâtiment',
    none: 'Aucun bâtiment n’est encore lié au lead.',
    open: 'Ouvrir le bâtiment',
  },
  energyLabel: {
    title: 'Étiquette énergie',
    grade: 'Classe énergétique',
    issued: 'Délivrée',
    openCertificate: 'Ouvrir le certificat',
    complete: 'Clôturer le lead',
    completeHelp:
      'Passe le lead à terminé et envoie le certificat énergétique par e-mail à la personne de contact',
    completeError: 'Impossible de clôturer le lead.',
  },
  inspection: {
    title: 'Visite',
    name: 'Nom',
    date: 'Date de visite',
    readSubmitted: 'Lire les données envoyées',
    open: 'Ouvrir la visite',
    create: "Créer l'inspection du bâtiment",
    createAgain: 'Créer une nouvelle inspection du bâtiment',
    noLead: "Le lead n'a pas pu être chargé.",
    fixErrorsFirst:
      "Corrigez d'abord les {count} erreurs des contrôles ci-dessus.",
    createHint:
      "L'inspection est créée à partir du formulaire ci-dessus, avec des valeurs standard là où le client n'a rien indiqué.",
    created: "L'inspection du bâtiment a été créée.",
    noBuilding: "Associez d'abord un bâtiment au lead.",
    noSubmission: "Aucun formulaire envoyé n'est encore associé au lead.",
    createError: "Impossible de créer l'inspection du bâtiment.",
    exists: "Une inspection du bâtiment vient d'être créée pour ce lead.",
    filledCount: '{count} valeurs ont été remplies avec des valeurs standard.',
  },
  filters: {
    allOpen: 'Tous les dossiers ouverts',
    waitingCustomer: 'En attente du client',
    readyForInspector: 'Prêt pour le conseiller',
    mine: 'Mes dossiers',
    completed: 'Terminés',
    stopped: 'Arrêtés',
    archived: 'Archivés',
  },
  columns: {
    contactPerson: 'Personne de contact',
    organizationNumber: 'Numéro d’organisation',
    address: 'Adresse',
    status: 'Statut',
    consultant: 'Conseiller',
    created: 'Créé le',
    actions: 'Action',
  },
  reminder: {
    send: 'Envoyer un rappel',
    sent: 'Rappel envoyé',
    help: 'Renvoie le lien du formulaire avec la même échéance',
    noDeadline:
      'Ce lead n’a pas encore d’échéance — envoyez d’abord la première notification',
    error: 'Impossible d’envoyer le rappel.',
  },
  status: {
    imported: 'Importé',
    created: 'Créé',
    formCompleted: 'Formulaire complété',
    inspectionStarted: 'Attribué à un conseiller',
    inspectionCompleted: 'Visite terminée',
    completed: 'Étiquette énergie délivrée',
    blocked: 'Bloqué',
    notEnoughInformation: 'Informations manquantes',
    cancelled: 'Archivé',
    unknown: 'Inconnu',
  },
  detail: {
    companyName: 'Nom de l’entreprise',
    internalComment: 'Note interne',
    internalCommentPlaceholder:
      'Visible uniquement par nous, jamais par le client',
    contactSection: 'Coordonnées',
    contactPerson: 'Personne de contact',
    phone: 'Téléphone',
    email: 'E-mail',
    companySection: 'Entreprise',
    organizationNumber: 'Numéro d’organisation',
    streetName: 'Nom de rue',
    houseNumber: 'Numéro',
    houseLetter: 'Lettre',
    postalCode: 'Code postal',
    city: 'Ville',
    mpidsSection: 'Identifiants de point de mesure',
    noMpids: 'Aucun identifiant de point de mesure enregistré',
    status: 'Statut',
    formSection: 'Formulaire client',
    formLink: 'Lien à envoyer au client',
    copyLink: 'Copier le lien',
    linkCopied: 'Lien copié.',
    formStatus: 'Statut du formulaire',
    formNotStarted: 'Pas encore ouvert',
    formDraft: 'En cours',
    formSubmitted: 'Envoyé',
  },
};

export default ENERGY_LABEL_LEADS;
